<template>
  <div id="app">
  <!-- <div :id="`app ${langue}`"> -->
    <router-view/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  data () {
    return {
    }
  },
  mounted () {
    this.setRem()
    window.addEventListener('resize', this.setRem)
  },
  destroyed () {
  // 移除监听事件
    window.removeEventListener('resize', this.setRem)
  },
  computed: {
    ...mapGetters(['langue', 'isH5'])
  },
  watch: {
    langue (newVal) {
      console.log('%c监听语言langue', 'background-color: green;color: #fff;', newVal)
    }
  },
  created () {
    // console.log('%c<---网站created--->', 'background-color: green;color: #fff;', this.langue)
  },
  methods: {
    setRem () {
      const baseSize = 20
      let designSize = 1920 // 设计图的尺寸
      // 屏幕尺寸小于1200时显示H5设计图
      if (document.documentElement.clientWidth <= 1200) {
        designSize = 750
        // 设置h5标志
        this.$store.dispatch('setIsH5', true)
        const scale = document.documentElement.clientWidth / designSize
        document.documentElement.style.fontSize = (baseSize * Math.min(scale, 2)) + 'px'
        // console.log('body-fontsize == ', document.documentElement.style.fontSize)
      } else {
        this.$store.dispatch('setIsH5', false)
      }
    }
  }
}
</script>

<style lang="less">
// -------------- 初始化 Start -------------- //
#app{
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  width: 100%;
  height: 100%;
}

body { overflow-x: auto; }
body, h1, h2, h3, h4, h5, h6, hr, p, blockquote, dl, dt, dd, ul, ol, li, pre, form, fieldset, legend, button, input, textarea, th, td { margin:0; padding:0; }
h1, h2, h3, h4, h5, h6{ font-size:100%; }
address, cite, dfn, em, var { font-style:normal; }
code, kbd, pre, samp { font-family:couriernew, courier, monospace; }
small{ font-size:12px; }
ul, ol { list-style:none; }
a { text-decoration:none; }
a:hover { text-decoration:none; }
sup { vertical-align:text-top; }
sub{ vertical-align:text-bottom; }
legend { color:#000; }
fieldset, img { border:0; }
button, input, select, textarea { font-size:100%; }
table { border-collapse:collapse; border-spacing:0; }
// -------------- 初始化 End -------------- //

// -------------- 滚动条滑块 Start -------------- //
* {
  // scrollbar-color: rgba(85, 85, 85, 0.4) rgba(231, 231, 231,.9);
  // scrollbar-width: thin;
  &::-webkit-scrollbar {
    display: block;
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-track{
    border-radius: 0px;
    background: transparent;
  }
  /*滑块*/
  &::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background-color: rgba(231, 231, 231,.9)
  }
  // 滑块效果
  &::-webkit-scrollbar-thumb:hover{
    border-radius: 5px;
    background-color: rgba(85, 85, 85, 0.4);
  }
}
// -------------- 滚动条滑块 End -------------- //
.ant-btn {
  &.ant-btn-blue {
    background: linear-gradient(146deg, #6297FF, #3E77FF);
    color: #FFFFFF;
    border-color: transparent;
    border: 1px solid rgba(216,221,230,1);
    &.ant-btn:hover,
    &.ant-btn:focus,
    &.ant-btn:active,
    &.ant-btn.active {
      box-shadow: 0px 6px 8px 0px rgba(126,145,193,0.35);
      background: linear-gradient(146deg, #6297FF, #3E77FF);
      color: #FFFFFF;
    }
  }
}

// -------------- 移动端适配 Start -------------- //

// 小屏show-pc不显示 show-pc不显示
@media screen and (max-width: 1200px) {
  .show-pc, .show-pc-inline{
    display: none!important;
  }
  .show-h5{ // 块级
    display: block!important;
  }
  .show-h5-inline{ // 行内块级
    display: inline-block!important;
  }
}

// 大屏show-pc显示 show-h5不显示
@media screen and (min-width: 1200px) {
  .show-pc{ // 块级
    display: block!important;
  }
  .show-pc-inline{ // 行内块级
    display: inline-block!important;
  }
  .show-h5, .show-h5-inline{
    display: none!important;
  }
}
// -------------- 移动端适配 End -------------- //

</style>



// WEBPACK FOOTER //
// src/App.vue